import React from "react";
import styled, { css } from "styled-components";
import { getAppThemeName } from "../../Services/appTheme";
import Logo from "../atoms/Logo";
import FormHeader from "../molecules/FormHeader";
import { useMediaQuery } from "react-responsive";
import Error from "../molecules/Error";
import { ErrorBoundary } from "../../Services/bugsnag";
const StyledPage = styled.div `
    overflow: auto;
    overflow-x: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    font-family: ${(props) => props.theme.fontBase} !important;

    @media only screen and (min-width: 768px) {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    ${(props) => props.appTheme === "inkassier" &&
    css `
            background-image: url("/img/wallpaper.png");
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;

            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                font-family: ${(props) => props.theme.fontHead};
            }

            @media only screen and (min-width: 768px) {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
            }
        `};

    ${(props) => props.appTheme === "invoned" &&
    css `
            background: ${(props) => props.theme.tertiary};

            @media only screen and (min-width: 1200px) {
                &:before {
                    content: none;
                }
            }
        `};
`;
const FirstLayer = styled.div `
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1031 1049.9'%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='216.352' y1='241.23' x2='923.483' y2='-304.838' gradientTransform='matrix(1 0 0 -1 0 675.89)'%3E%3Cstop offset='0' stop-color='%239f56c5' stop-opacity='.39'/%3E%3Cstop offset='.38' stop-color='%23924bb4'/%3E%3Cstop offset='1' stop-color='%23601e6f'/%3E%3C/linearGradient%3E%3Cpath d='M1031 281.4L0 408.4v641.5h1031V281.4z' opacity='.3' fill='url(%23a)'/%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='167.555' y1='703.402' x2='473.613' y2='199.495' gradientTransform='matrix(1 0 0 -1 0 675.89)'%3E%3Cstop offset='0' stop-color='%23601e6f'/%3E%3Cstop offset='1' stop-color='%239f56c5'/%3E%3C/linearGradient%3E%3Cpath d='M0 0v562.8l547.1-64.7c93.5-11 163.2-80.4 163.2-162.4V0H0z' opacity='.18' fill='url(%23b)'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;

    @media only screen and (min-width: 1200px) {
        display: ${(props) => props.appTheme === "invoned" ? "block" : "none"};
        width: 55%;
    }
`;
const SecondLayer = styled.div `
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    background-image: url("/img/image.png");
    background-repeat: no-repeat;
    background-size: cover;
    width: 45%;
    height: 100%;

    @media only screen and (min-width: 1200px) {
        display: ${(props) => props.appTheme === "invoned" ? "block" : "none"};
    }

    &:before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: linear-gradient(
            to right,
            rgba(96, 30, 111, 1),
            rgba(96, 30, 111, 0)
        );
    }

    &:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: linear-gradient(
            to right,
            rgba(96, 30, 111, 1),
            rgba(96, 30, 111, 0)
        );
    }
`;
const Shape = styled.div `
    position: fixed;
    bottom: 0;
    left: -150px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='606.854' height='607.49'%3E%3Cdefs%3E%3ClinearGradient id='a' y1='.5' x2='1' y2='.5' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23601e6f' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%239f56c5'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg data-name='Group 2988'%3E%3Cpath data-name='Path 89' d='M639.345 798.911h157.722c2 3.171 4.362 6.075 6.231 9.309 4.154 7.169 7.521 14.812 11.109 22.339H678.479a191.74 191.74 0 00-24.467-22.339c-4.623-3.465-9.732-6.265-14.667-9.309zm175.391 290.508H678.618a190.558 190.558 0 01-38.584 31.653H797.4a303.516 303.516 0 0017.334-31.653zM663.76 1237.288a303.663 303.663 0 0054.535-31.636H540.359l25.729-26.463H750.07a308.069 308.069 0 0028.726-31.654H567.3c-102.749 15.712-198.78-54.846-214.491-157.6a188.164 188.164 0 01-2.157-29.934c-1.34-103.42 81.412-188.345 184.833-189.685a187.185 187.185 0 0130.86 2.156h212.334a305.583 305.583 0 00-28.98-31.654H540.318l25.729-26.463h151.814a303.593 303.593 0 00-54.35-31.636H540.318l24.12-24.826c-8.013-.642-15.934-1.643-24.12-1.643-167.663.225-303.525 136.087-303.745 303.75.188 167.676 136.069 303.557 303.745 303.745l25.729-26.463zm65.609-264.044a188.548 188.548 0 01-4.918 31.636H840.4a300.548 300.548 0 003.032-31.636zm-29.918-116.216a191.267 191.267 0 0116.4 31.653h119.278a300.389 300.389 0 00-9.7-31.653zM716 1031.343a188.809 188.809 0 01-16.576 31.636h126.304a299.087 299.087 0 009.547-31.636zm8.678-116.2a189.711 189.711 0 014.583 31.636h113.974a305.7 305.7 0 00-2.684-31.636z' fill='url(%23a)' transform='translate(-236.573 -656.255)' opacity='.636'/%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    width: 600px;
    height: 600px;
`;
const Container = styled.div `
    width: 100%;
    height: ${(props) => props.appTheme === "invoned" ? "calc(100% - 86px)" : "100%"};
    max-width: 600px;
    margin: 20px auto;
    padding: 0 10px;
    z-index: 2;

    @media only screen and (min-width: 576px) {
        height: ${(props) => props.appTheme === "invoned" ? "calc(100% - 280px)" : "100%"};
    }

    @media only screen and (min-width: 768px) {
        padding: 0;
    }

    @media only screen and (min-width: 992px) {
        height: ${(props) => props.appTheme === "invoned"
    ? "calc(100% - 280px)"
    : "calc(100% - 177px)"};
    }

    @media only screen and (min-width: 1400px) {
        margin: 86px auto 20px;
    }
`;
// @ts-ignore
const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 992 });
    return isDesktop ? children : null;
};
// @ts-ignore
const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 991 });
    return isMobile ? children : null;
};
const Layout = ({ children }) => (React.createElement(StyledPage, { appTheme: getAppThemeName(), id: "page-wrapper" },
    React.createElement(Desktop, null,
        React.createElement(Logo, { appTheme: getAppThemeName() })),
    React.createElement(FirstLayer, { appTheme: getAppThemeName() }),
    React.createElement(SecondLayer, { appTheme: getAppThemeName() },
        React.createElement(Shape, null)),
    React.createElement(Container, { appTheme: getAppThemeName() },
        React.createElement(Mobile, null,
            React.createElement(Logo, { appTheme: getAppThemeName() })),
        React.createElement(FormHeader, null),
        React.createElement(ErrorBoundary, { FallbackComponent: Error }, children))));
export default Layout;
